// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"236214ef","239":"8c12f3b4","732":"98793e18","762":"0da7a194"}[chunkId] + ".chunk.js";
};